const companyCategoryItems = [
    { titleSelect: 'Office of the Treasury and State Treasury (KPPN) - Central Government', valSelect: 'S131101L' },
    { titleSelect: 'Ministry of Finance - Central Government', valSelect: 'S131102L' },
    { titleSelect: 'Ministry of Defence - Central Government', valSelect: 'S131103L' },
    { titleSelect: 'Ministry of Environment and Forestry - Central Government', valSelect: 'S131104L' },
    { titleSelect: 'Ministry of Agriculture - Central Government', valSelect: 'S131105L' },
    { titleSelect: 'Ministry of Mines and Energy - Central Government', valSelect: 'S131106L' },
    { titleSelect: 'Ministry of Religious - Central Government', valSelect: 'S131107L' },
    { titleSelect: 'Ministry of State-owned Enterprises - Central Government', valSelect: 'S131108L' },
    { titleSelect: 'Ministry of Culture and Education - Central Government', valSelect: 'S131109L' },
    { titleSelect: 'Ministry of Public Works and Human Settlements - Central Government', valSelect: 'S131110L' },
    { titleSelect: 'Ministry of Health - Central Government', valSelect: 'S131111L' },
    { titleSelect: 'Ministry of Transportation - Central Government', valSelect: 'S131112L' },
    { titleSelect: 'Other Ministries - Central Government', valSelect: 'S131199L' },
    { titleSelect: 'Agency and Government Institutions - Central Government', valSelect: 'S131197L' },
    { titleSelect: 'Public Health Service Agency', valSelect: 'S1311981L' },
    { titleSelect: 'Public Education Service Agency', valSelect: 'S1311982L' },
    { titleSelect: 'Other Public Service Agency', valSelect: 'S1311989L' },
    { titleSelect: 'Province - Local Government', valSelect: 'S131301L' },
    { titleSelect: 'Municipal - Local Government', valSelect: 'S131302L' },
    { titleSelect: 'District - Local Government', valSelect: 'S131303L' },
    { titleSelect: 'Regional Public Service - Province', valSelect: 'S1313981L' },
    { titleSelect: 'Regional Public Service - Municipal', valSelect: 'S1313982L' },
    { titleSelect: 'State-owned Enterprises - Public - Non Financial Institution', valSelect: 'S110011L' },
]

export default companyCategoryItems;